// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2YIsd","inner":"Footer_inner__1eYrx"};